module.exports = {"title":"낙구지점 위치 통계","selectGolfClub":"골프클럽을 선택하세요.","month1":"1개월","month3":"3개월","month6":"6개월","tooltip":"검색한 기간의 통합 통계입니다.","selectType":"유형을 선택하세요.","point":"포인트"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cr001.json
// module id = meUY
// module chunks = 2